import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationDamageList = _resolveComponent("ConfirmationDamageList")!
  const _component_ConfirmationOverlay = _resolveComponent("ConfirmationOverlay")!

  return (_ctx.confirmationShown)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.popupStage === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_ConfirmationOverlay, {
                acceptTheme: "primary",
                rejectTheme: "return",
                titleText: "The following damage was previously reported on this trailer. Is this damage still present?",
                acceptText: "Yes",
                rejectText: "No",
                popupStage: _ctx.popupStage,
                onConfirmStage: _ctx.changeStage
              }, {
                warning: _withCtx(() => [
                  _createVNode(_component_ConfirmationDamageList, {
                    trailerAssessmentResult: _ctx.trailerAssessmentResult,
                    includeCriticalDamageMessage: true
                  }, null, 8, ["trailerAssessmentResult"])
                ]),
                _: 1
              }, 8, ["popupStage", "onConfirmStage"])
            ]))
          : (_ctx.popupStage === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.acceptedFirstStage)
                  ? (_openBlock(), _createBlock(_component_ConfirmationOverlay, {
                      key: 0,
                      acceptTheme: "primary",
                      rejectTheme: "return",
                      subtitleStyle: "strong-subtitle",
                      titleText: "Please Update/Report any damage through the Trailer Assessment.",
                      acceptText: "Okay",
                      rejectText: "Go back",
                      onAccept: _ctx.onAccept,
                      onReject: _ctx.onReject,
                      popupStage: _ctx.popupStage
                    }, null, 8, ["onAccept", "onReject", "popupStage"]))
                  : (_openBlock(), _createBlock(_component_ConfirmationOverlay, {
                      key: 1,
                      acceptTheme: "primary",
                      rejectTheme: "return",
                      titleText: "Damage has been cleared. Please report any new damage through the Trailer Assessment.",
                      acceptText: _ctx.acceptText,
                      rejectText: "Go back",
                      confirmationLoading: _ctx.isLoading,
                      onAccept: _ctx.onAccept,
                      onReject: _ctx.onReject,
                      popupStage: _ctx.popupStage
                    }, null, 8, ["acceptText", "confirmationLoading", "onAccept", "onReject", "popupStage"]))
              ]))
            : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}